import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67d79083&scoped=true&"
import script from "./index.vue.js?vue&type=script&lang=js&"
export * from "./index.vue.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=67d79083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d79083",
  null
  
)

export default component.exports